import React, { useState } from 'react';
import { Lock } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import { useAuth } from '../../context/AuthContext';
import PasswordChangeForm from '../../components/dashboard/PasswordChangeForm';
import ProfileView from '../../components/dashboard/ProfileView';

export default function AdminProfilePage() {
  const { t } = useLanguage();
  const { user } = useAuth();
  const [passwordOpen, setPasswordOpen] = useState(false);

  return (
    <>
      <header className="dash-page-head" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 16, flexWrap: 'wrap' }}>
        <div>
          <h1>Mon profil</h1>
          <p>Informations personnelles et mot de passe.</p>
        </div>
        <button type="button" className="btn btn-primary" onClick={() => setPasswordOpen(true)}>
          <Lock size={15} /> {t.auth?.changePassword || 'Changer le mot de passe'}
        </button>
      </header>

      <ProfileView user={user} space="admin" />

      {passwordOpen && (
        <section className="dash-panel" style={{ marginTop: 16 }}>
          <header className="dform-section-head">
            <Lock size={17} />
            <h4>{t.auth?.changePassword || 'Changer le mot de passe'}</h4>
          </header>
          <PasswordChangeForm />
        </section>
      )}
    </>
  );
}
